// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__1HEdk","list":"styles_list__56d6H"};